import React, { useState, useEffect } from "react";
import StyledTable from "../../common/StyledTable";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import DetailsModal from "../admin-concursos/DetailsModal";
import { hide_show } from "../../utils/drop_down";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import IconButton from "@material-ui/core/Button";
import { handleLoadingConcursoError } from "../../utils/errors";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  item: {
    "& .MuiTreeItem-iconContainer svg": { fontSize: "24px" },
    "& .MuiTreeItem-label": { fontSize: "24px" },
    "&.Mui-selected .MuiTreeItem-label": { background: "none !important" },
  },
});

type ConcursosFacultadProps = {
  visible: boolean;
  loading: boolean;
  concursosFacultad: ConcursosFacultad[];
};

type ConcursoRevisado = {
  concurso: Concurso;
  fecha_envio: string;
  estado: string;
  comentario: string;
};

type ConcursosFacultad = {
  nombre_facultad: string;
  data: ConcursoRevisado[];
};

const ConcursosFacultad: React.FC<ConcursosFacultadProps> = (props) => {
  const classes = useStyles();
  if (props.loading) {
    return <StyledTable loading />;
  }
  if (!props.visible) {
    return (
      <div
        style={{
          paddingTop: "1em",
          paddingLeft: "2em",
          paddingRight: "2em",
        }}
      >
        <p>No hay concursos disponibles.</p>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div>
        {props.concursosFacultad.map(
          (concursoFacultad: ConcursosFacultad, index) => {
            return (
              <React.Fragment key={index}>
                <div
                  style={{
                    paddingLeft: "2em",
                    paddingRight: "2em",
                  }}
                >
                  <TreeItem
                    nodeId={concursoFacultad.nombre_facultad}
                    className={classes.item}
                    label={
                      concursoFacultad.nombre_facultad
                        ? concursoFacultad.nombre_facultad
                        : ""
                    }
                  >
                    <div
                      id={concursoFacultad.nombre_facultad + "LT"}
                      className="mt-3"
                    >
                      <Concurso
                        key={concursoFacultad.nombre_facultad}
                        rows={concursoFacultad.data.map(
                          (concursoRevisado: ConcursoRevisado) =>
                            filaConcurso({
                              codigo: concursoRevisado.concurso.codigo,
                              nombre: concursoRevisado.concurso.nombre,
                              apertura: concursoRevisado.concurso.fecha_inicio,
                              cierre: concursoRevisado.concurso.fecha_termino,
                              concursoId: concursoRevisado.concurso.id,
                              numPostulantes: 0,
                              creador:
                                concursoRevisado.concurso.id_usuario_creador,
                              contacto:
                                concursoRevisado.concurso.id_usuario_contacto,
                              publicacion:
                                concursoRevisado.concurso.fecha_aviso_diario,
                              fecha_envio: concursoRevisado.fecha_envio,
                              estado: concursoRevisado.estado,
                            })
                        )}
                      />
                    </div>
                  </TreeItem>
                </div>
              </React.Fragment>
            );
          }
        )}
      </div>
    </React.Fragment>
  );
};

type Concurso = {
  id: number;
  codigo: string;
  nombre: string;
  fecha_inicio: string;
  fecha_termino: string;
  fecha_aviso_diario: string;
  id_facultad: number;
  id_usuario_creador: number;
  id_usuario_contacto: number;
};

type ConcursoProps = {
  rows: ({ content: string } | { content: JSX.Element })[][];
};

const Concurso: React.FC<ConcursoProps> = (props) => {
  const rows = props.rows;
  const headers = [
    { content: "Código" },
    { content: "Nombre" },
    { content: "Fecha de Publicación en el Diario" },
    { content: "Estado" },
    //{ content: "Fecha de Apertura" },
    { content: "Acciones" },
  ];

  return <StyledTable headers={headers} rows={rows} />;
};

const filaConcurso = (props: FilaConcursoProps) => {
  const fechaPublicacion = moment(props.publicacion).locale("es").format("LL");
  const getVariant = (estado: string) => {
    switch (estado) {
      case "Rechazado":
        return <strong style={{ color: "#f50057" }}>Rechazado</strong>;
      case "Aprobado":
        return <strong style={{ color: "#46794b" }}>Aprobado</strong>;
      case "Abierto":
        return <strong style={{ color: "#46794b" }}>Abierto</strong>;
      case "Pendiente Acta":
        return <strong style={{ color: "#2a4988" }}>Pendiente Acta</strong>;
      default:
        return <div />;
    }
  };
  return [
    { content: props.codigo, style: { width: "1px" } },
    { content: props.nombre },
    { content: fechaPublicacion, style: { width: "254px" } },
    { content: getVariant(props.estado), style: { width: "160px" } },
    //{ content: fechaApertura },
    {
      content: (
        <div className="d-flex justify-content-center">
          <DetailsModal label="Detalles" concursoId={props.concursoId} />
        </div>
      ),
      style: { width: "15px" },
    },
  ];
};

type FilaConcursoProps = {
  codigo: string;
  nombre: string;
  apertura: string;
  cierre: string;
  concursoId: number;
  numPostulantes: number;
  creador: number;
  contacto: number;
  publicacion: string;
  fecha_envio: string;
  estado: string;
};

type AdminConcursosReviewedProps = {
  index: number;
};

const AdminConcursosReviewed: React.FC<AdminConcursosReviewedProps> = (
  props
) => {
  const [concursos, setConcursos] = useState([]);
  const [loadingConcursos, setLoadingConcursos] = useState(true);
  const [error, setError] = useState(false);
  const [expanded, setExpanded] = React.useState([]);

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  useEffect(() => {
    /**
         function sortByFechaPublicacion(data: []) {
            let sortedData = data.sort((a: any, b: any) => new Date(b.fecha_aviso_diario).getTime() - new Date(a.fecha_aviso_diario).getTime());
            return sortedData;
        }*/

    let api_route = "/concursosRevisados/";

    function handleError(error: any): void {
      setError(true);
      handleLoadingConcursoError(
        error,
        (window as any).ENV.URL_FRONT + "AdminConcursos/?tab=" + props.index
      );
    }

    axios
      .get((window as any).ENV.API_URL + api_route)
      .then((res) => {
        setConcursos(res.data);
        setExpanded(res.data.map((concurso) => concurso.nombre_facultad));
        setLoadingConcursos(false);
      })
      .catch((error) => handleError(error));
  }, []);

  if (!error)
    return (
      <TreeView
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        expanded={expanded}
        onNodeToggle={handleToggle}
      >
        <ConcursosFacultad
          loading={loadingConcursos}
          visible={concursos.length > 0}
          concursosFacultad={concursos}
        />
      </TreeView>
    );
  return null;
};

export default AdminConcursosReviewed;
